module.exports = __webpack_public_path__ + "static/img/6.e1a422ae.png";